import { StateReducer } from './createStateReducer';

export type OnAction<D extends Record<string, unknown>> = (
  event: StateReducer<D>
) => void;

type ObserveAction<D extends Record<string, unknown>> = {
  onAction?: OnAction<D>;
};

export function observeAction<D extends Record<string, unknown>>({
  onAction,
}: ObserveAction<D>) {
  return (event: StateReducer<D>) => {
    onAction?.(event);
    return event;
  };
}
